import { __decorate } from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
/**
 * Simplicity components
 */
import { ActionButtonComponent } from './components/action-button';
import { RoamingStepperComponent } from './components/roaming-stepper';
import { RoamingStepperItemComponent } from './components/roaming-stepper/roaming-stepper-item';
import { LabelComponent } from './components/label';
import { RadioButtonComponent } from './components/radio-button';
import { TextInputComponent } from './components/text-input';
import { NotificationComponent } from './components/notification';
import { CheckboxComponent } from './components/checkbox';
import { ActionDialogComponent } from './components/action-dialog';
import { SimpleDialogComponent } from './components/simple-dialog';
import { InfoIComponent } from './components/info-i';
import { DateDropdownComponent } from './components/date-dropdown';
/**
 * Enterprise common modules
 *
 * Contains simplicity components
 * Shared services for data and session management
 */
var SharedModule = /*@__PURE__*/ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/shared.module.ts
// module id = null
// module chunks = 